<template>
    <div class="medal-wrapper">
        <div class="medal-nav">
            <a href="javascript:;"  class="nav-list" :class="{'active':index === curIndex}"  v-for="(item,index) in medalTitleList" :key="index" @click="medalInfor(item.type,index)">{{item.title}}</a>
        </div>
        <div class="bottom-medal-list">
            <div class="all-medal" v-if="allMedal.length">
                <div class="medal-content">
                    <div class="medal-list" v-for="(item,index) in allMedal" :key="index">
                        <div class="title-wrapper">
                            <h3 class="title">{{filterXSS(item.kind)}}</h3>
                            <span class="line"></span>
                        </div>
                        <div class="medal-type">
                            <ul>
                                <li class="clearfix" v-for="(medal,index) in item.data" :key="index">
                                    <p class="desctibe" v-if = "medal.type">
                                        <img src="../images/personal_center/medal_03.png" v-if = "medal.type === 'Gold'">
                                        <img src="../images/personal_center/medal_02.png" v-if = "medal.type === 'Silver'">
                                        <img src="../images/personal_center/medal_01.png" v-if = "medal.type === 'Copper'">
                                        <span :class = "['desc-text',{'sliver-text': medal.type === 'Sliver'},{'copper-text': medal.type === 'Copper'}]">{{medal.type_text}}</span>
                                    </p>
                                    <p class="condition">{{filterXSS(medal.desc)}}</p>
                                    <p class="gain-count">{{filterXSS(medal.status)}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-medal" v-if="!allMedal.length && !isMedalLoading">
                <img src="../images/developer/null.png" alt="" />
                <p>暂无获奖记录！</p>
            </div>
            <loading :ifLoadingStart="isMedalLoading" style="padding: 100px 0"></loading>
            <v-alert :options="options"></v-alert>
        </div>
    </div>
</template>
<script>
 import loading from './loading.vue';
 import vAlert from "./alert.vue";
export default {
    components: {
        loading,
        "v-alert": vAlert
    },
    data() {
        return {
          curIndex: 0,
          allMedal: [],
          medalTitleList: [{
                title: '社区奖牌',
                type: 'all'    
            },{
                title: '已获得的奖牌',
                type: 'my' 
            },{
                title: '未获得的奖牌',
                type: 'notmy' 
            },{
                title: '金牌',
                type: 'Gold' 
            },{
                title: '银牌',
                type: 'Silver' 
            },{
                title: '铜牌',
                type: 'Copper' 
            }],
            medalType: 'all',
            myMedal: '',
            isMedalLoading: true,
            options: { // 消息弹窗
                msgText: "",
                msgIsSuccess: true
            }
        }
    },
    mounted () {
        this.initShowData();
        this.myMedal = localStorage.getItem("medalType");
        if (!this.myMedal) {
            this.medalInfor('all',0);
        }
    },
    destroyed () {
        localStorage.removeItem("medalType");
    },
    methods: {
        initShowData () {
            let type = localStorage.getItem("medalType");
            if (type) {
                this.curIndex = 1;
                this.medalType = 'my';
                this.medalList(this.medalType);
            }
        },
        medalInfor (type,index) {
            this.curIndex = index;
            this.medalType = type;
            this.medalList(this.medalType);
        },
        medalList (type) {
            let requestUrl = `forum/person/medal/?keyword=${type}`;
            if (type === 'all') {
                requestUrl = 'forum/person/all_medal/';
            }
            axios.get(myUrl + requestUrl).then(res => {
                if (!res.data.result) return;
                this.isMedalLoading = false;
                this.allMedal = res.data.data;
            })
                .catch(error => {
                    this.options = {
                        msgText: res.data.message,
                        msgIsSuccess: false
                    };
                });
        }
    }
}
</script>

<style lang="scss" scoped type="text/scss">
    .medal-wrapper{
        padding-top: 50px;
        margin: 60px auto 0 auto;
        width: 1180px;
        .medal-nav{
           margin-bottom: 20px;
           background-color: #ffffff;
	       border: solid 1px #dddddd;
           .nav-list{
                display: inline-block;
                padding: 0 20px;
                height: 46px;
                line-height: 46px;
                font-size: 14px;
                color: #7b7d8a;
                text-align: center;
                &:hover,&.active{
                    color: #fff;
                    background-color: #4491e1;     
                }
           }
        }
    }
    .bottom-medal-list{
        padding: 45px 0 49px 0;
        margin-bottom: 60px;
        width: 100%;
        background: #fff;
        box-shadow: 0px 2px 4px 0px rgba(9, 11, 26, 0.1);
        .loading{
            margin-top: 0;
        }
    }
    .medal-content{
       .medal-list{
           margin-bottom: 56px;
           &:last-child{
               margin-bottom: 0;
           }
       }
       .title-wrapper{
           padding: 0 0 28px 0;
           line-height: 0;
           text-align: center;
           .title{
               line-height: 38px;
               font-size: 32px;
               letter-spacing: 1px;
	           color: #4f515e;
            }
            .line{
                display: inline-block;
                margin-top: 12px;
                width: 30px;
                height: 2px;
                background-color: #57a3f1;
            }
       }
       .medal-type{
           padding: 0 120px;
           li{
               padding:10px 0;
               border-bottom: 1px solid #f4f4f4;
               p{
                  float:left;
                  width: 27.66%;
                  height: 32px;
                  line-height: 32px;
                  font-size: 14px;
                  font-weight: normal;
                  color: #888991;
                  &.desctibe{
                      font-size: 0;
                      position: relative;
                      img{
                          position: absolute;
                      }
                  }
                  &.condition{
                      width: 44.68%;
                  }
                  &.gain-count{
                      text-align: right;
                      color: #aaaaaa;
                  }
                  img,.desc-text{
                      display:inline-block;
                      vertical-align: middle;
                  }
                  .desc-text{
                      padding: 0 13px 0 36px;
                      height: 26px;
                      line-height: 26px;
                      color: #e0b15f;
                      font-size: 14px;
                      background-color: #fffae5;
	                  border-radius: 2px;
                      &.sliver-text{
                          background: #f0f6fa;
                          color: #acafaf;
                      }
                      &.copper-text{
                           background: #fff4e5;
                           color: #c48c66;
                      }
                  }
                  
               }
           }
       }    
    }

    .no-medal{
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        padding: 135px 0;
        background-color: #ffffff;
        p{
            color: #878996;
            font-size: 16px;
            margin-top: 25px;
        }
    }
</style>





// WEBPACK FOOTER //
// medal.vue?54c2c85d